<template>
  <div class="space-y-2">
    <p>
      As our services relate to betting search and comparison, they are intended for adults aged 18 and over, or the legal age for gambling-related content in your jurisdiction (whichever is higher).
    </p>
    <p>
      We do not knowingly place cookies or store data for anyone under this age.
    </p>
    <p>
      If you believe we have inadvertently stored data for a minor, please contact us immediately for removal.
    </p>
  </div>
</template>